<script setup lang="ts">
import { defineProps, computed } from "vue";
import { useTheme } from "~/composables/useTheme";

const { colors, themeName } = useTheme();

const props = defineProps({
  text: {
    type: String,
    required: true,
  },
  color: {
    type: String,
    default: "#0027AF",
  },
  width: {
    type: String,
    default: "auto",
  },
  borderRadius: {
    type: String,
    default: "14px",
  },
  noBorder: {
    type: Boolean,
    default: false,
  },
});

// Compute width
const computedWidth = () => {
  if (props.width === "full") return "100%";
  if (props.width === "auto") return "auto";
  return props.width;
};

// Theme-based background color
const bgColor = computed(() =>
  themeName.value === "dark" ? "#F9FDF440" : "#F9FDF4"
);

// Fixed border color
const borderColor = "#0AA245";

const icon = `<svg xmlns="http://www.w3.org/2000/svg" height="16px" viewBox="0 0 24 24" width="16px" fill="#0AA245">
  <path d="M0 0h24v24H0z" fill="none"/>
  <path d="M12 1L3 5v6c0 5.55 3.84 10.74 9 12 5.16-1.26 9-6.45 9-12V5l-9-4zm-2 16l-4-4 1.41-1.41L10 14.17l6.59-6.59L18 9l-8 8z"/>
  </svg>`;
</script>

<template>
  <div
    :style="{
      display: 'flex',
      alignItems: 'center',
      gap: icon ? '3px' : '0',
      width: computedWidth(),
      backgroundColor: bgColor,
      border: props.noBorder ? 'none' : `0.5px solid ${borderColor}`,
      color: colors.primaryText,
      borderRadius: props.borderRadius,
      padding: '4px 6px',
      cursor: 'default',
      marginBottom: '21px',
    }"
  >
    <span v-if="icon" v-html="icon" style="display: flex"></span>
    <small><b>{{ text }}</b></small>
  </div>
</template>

<style scoped>
small {
  font-size: 11px;
}
@media (min-width: 1025px) {
  small {
    font-size: 12px;
  }
}
</style>
